// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestConnectLine {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private _connectLine1?: vf.gui.ConnectLine;
    private _connectLine2?: vf.gui.ConnectLine;
    private _connectLine3?: vf.gui.ConnectLine;
    private _container?: vf.gui.Container;
    private _rect1?: vf.gui.Rect;
    private _rect2?: vf.gui.Rect;
    private _e4Rect1?: vf.gui.Rect;
    private _e4Rect2?: vf.gui.Rect;
    private _e4Line1?: vf.gui.ConnectLine;
    private _buttonList: vf.gui.Label[] = [];

    private _timeOutId = -1;

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {


        // =========  示例1，自定义坐标 ============== //
        const connectLine1 = this._connectLine1 = new vf.gui.ConnectLine;
        connectLine1.isAnimation = true;
        connectLine1.sourcePostion = [15, 15]; // 设置源坐标
        connectLine1.targetPostion = [350, 15];// 设置目标坐标
        connectLine1.lineColor = 0xffffff; // 线条颜色
        connectLine1.lineWidth = 2;// 线条宽度
        uiStage.addChild(connectLine1);

        // =========  示例2，手动触发画线 ============== //
        const connectLine2 = this._connectLine2 = new vf.gui.ConnectLine;
        connectLine2.isAnimation = true;
        connectLine2.sourcePostion = [15, 40];
        connectLine2.targetPostion = [350, 40];
        connectLine2.lineColor = 0xffff00;
        connectLine2.lineWidth = 2;
        connectLine2.autoPlay = false; // 是否自动播放 ，默认自动播放
        uiStage.addChild(connectLine2);
        this._timeOutId = setTimeout(() => { // 3秒后触发画线
            connectLine2.play = 2; // 在非自动播放模式下，触发播放画线，1（source -> target），2倒序播放（target -> source)
        }, 3000);


        // =========  示例3，绑定到容器 ============== //
        const container = this._container = new vf.gui.Container();
        container.x = 10;
        container.y = 100;
        uiStage.addChild(container);

        const rect1 = this.getNewRect(container);
        const rect2 = this.getNewRect(container, 240, 0);

        const connectLine3 = this._connectLine3 = new vf.gui.ConnectLine;
        connectLine3.isAnimation = true;
        connectLine3.source = rect1;
        connectLine3.sourcePostion = 'center';//绑定容器的中心点
        connectLine3.target = rect2;
        connectLine3.targetPostion = 'center';//绑定容器的中心点
        connectLine3.lineColor = 0xff00cc;
        connectLine3.lineWidth = 2;
        uiStage.addChild(connectLine3);

        // =========  示例4 点击矩形进行连线 ============== //
        const e4Rect1 = this._e4Rect1 = this.getNewRect(container, 0, 160);
        const e4Rect2 = this._e4Rect2 = this.getNewRect(container, 240, 280);

        const e4Line1 = this._e4Line1 = this.getNewConnectLine(container, e4Rect1, e4Rect2);

        e4Rect1.on(vf.gui.Interaction.TouchMouseEvent.onClick, () => {
            e4Line1.isClear = true;
            e4Line1.lineColor = 0xffcc00;
            e4Line1.play = 2;
        });
        e4Rect2.on(vf.gui.Interaction.TouchMouseEvent.onClick, () => {
            e4Line1.isClear = true;
            e4Line1.lineColor = 0xffffff;
            e4Line1.play = 1;
        });

        function hoverFun3() {
            console.log("COMPLETE");
        }

        this.getButton('设置/取消play', () => {

            if (e4Line1.play != 1) {

                e4Line1.play = 1;
            } else {
                e4Line1.play = 2;
            }
        }, uiStage, 650, 0);

        this.getButton('设置速度2000毫秒', () => {

            e4Line1.speed = 2000;
            if (e4Line1.play != 1) {

                e4Line1.play = 1;
            } else {
                e4Line1.play = 2;
            }
        }, uiStage, 650, 0);

        this.getButton('设置/取消autoPlay', () => {

            if (connectLine2.autoPlay != true) {

                connectLine2.autoPlay = true;
            } else {
                connectLine2.autoPlay = false;
            }
        }, uiStage, 650, 0);


        this.getButton('设置/取消source', () => {

            if (connectLine3.source != undefined) {

                connectLine3.source = undefined;
            } else {
                connectLine3.source = rect1;
            }
        }, uiStage, 650, 0);


        this.getButton('设置/取消sourcePostion', () => {

            if (connectLine2.sourcePostion != [20, 100]) {

                connectLine2.sourcePostion = [20, 100];
            } else {
                connectLine2.sourcePostion = [15, 40];
            }
        }, uiStage, 650, 0);



        this.getButton('设置/取消target', () => {

            if (connectLine3.target != undefined) {

                connectLine3.target = undefined;
            } else {
                connectLine3.target = rect2;
            }
        }, uiStage, 650, 0);



        this.getButton('设置/取消targetPostion', () => {

            if (connectLine3.targetPostion != "centerBottom") {

                connectLine3.targetPostion = "centerBottom";
            } else {
                connectLine3.targetPostion = 'center';
            }
        }, uiStage, 650, 0);


        this.getButton('设置/取消lineColor', () => {

            if (connectLine2.lineColor != 0xffffff) {

                connectLine2.lineColor = 0xffffff;
            } else {
                connectLine2.lineColor = 0xffff00;
            }
        }, uiStage, 650, 0);


        this.getButton('设置/取消lineWidth', () => {

            if (connectLine2.lineWidth != 20) {

                connectLine2.lineWidth = 20;
            } else {
                connectLine2.lineWidth = 2;
            }
        }, uiStage, 650, 0);



        this.getButton('设置/取消isAnimation', () => {

            if (connectLine2.isAnimation != false) {

                connectLine2.isAnimation = false;
            } else {
                connectLine2.isAnimation = true;
            }
        }, uiStage, 650, 0);


        this.getButton('设置/取消isClear', () => {

            if (e4Line1.isClear != false) {

                e4Line1.isClear = false;
            } else {
                e4Line1.isClear = true;
            }
        }, uiStage, 650, 0);


        let b3 = false;
        this.getButton('设置/取消CHANGE事件', () => {

            if (!b3) {

                b3 = true;
                connectLine2.off(vf.gui.Interaction.ComponentEvent.COMPLETE, hoverFun3);

            } else {
                b3 = false;
                connectLine2.on(vf.gui.Interaction.ComponentEvent.COMPLETE, hoverFun3);

            }


        }, uiStage, 650, 0);

    }

    private getNewRect(parent: vf.gui.DisplayObject, x = 0, y = 0) {
        const rect = new vf.gui.Rect();
        rect.isClick = true;
        rect.x = x;
        rect.y = y;
        rect.width = 100;
        rect.height = 100;
        rect.color = 0xffffff;
        rect.lineColor = 0xff00cc;
        rect.lineWidth = 1;
        parent.addChild(rect);
        return rect;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private getNewConnectLine(parent: vf.gui.DisplayObject, source: any, target: any) {
        const connectLine = new vf.gui.ConnectLine;
        connectLine.isAnimation = true;
        connectLine.source = source;
        connectLine.sourcePostion = 'center';//绑定容器的中心点
        connectLine.target = target;
        connectLine.targetPostion = 'center';//绑定容器的中心点
        connectLine.lineColor = 0xff00cc;
        connectLine.lineWidth = 2;
        connectLine.autoPlay = false; // 是否自动播放 ，默认自动播放
        parent.addChild(connectLine);
        return connectLine;
    }




    private posY = 15;
    private getButton(title: string, clickFun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 30;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, clickFun);
        target.addChild(button);
        this.posY = this.posY + 30 + y;
        this._buttonList.push(button);
        return button;
    }
    private onRelease() {
        if (this._connectLine1) {
            this._connectLine1.removeAllListeners();
            this._connectLine1.parent && this._connectLine1.parent.removeChild(this._connectLine1);
            this._connectLine1.release();
            this._connectLine1 = undefined;
        }
        if (this._connectLine2) {
            this._connectLine2.removeAllListeners();
            this._connectLine2.parent && this._connectLine2.parent.removeChild(this._connectLine2);
            this._connectLine2.release();
            this._connectLine2 = undefined;
        }
        if (this._connectLine3) {
            this._connectLine3.removeAllListeners();
            this._connectLine3.parent && this._connectLine3.parent.removeChild(this._connectLine3);
            this._connectLine3.release();
            this._connectLine3 = undefined;
        }
        if (this._container) {
            this._container.removeAllListeners();
            this._container.parent && this._container.parent.removeChild(this._container);
            this._container.release();
            this._container = undefined;
        }
        if (this._rect1) {
            this._rect1.removeAllListeners();
            this._rect1.parent && this._rect1.parent.removeChild(this._rect1);
            this._rect1.release();
            this._rect1 = undefined;
        }
        if (this._rect2) {
            this._rect2.removeAllListeners();
            this._rect2.parent && this._rect2.parent.removeChild(this._rect2);
            this._rect2.release();
            this._rect2 = undefined;
        }
        if (this._e4Rect1) {
            this._e4Rect1.removeAllListeners();
            this._e4Rect1.parent && this._e4Rect1.parent.removeChild(this._e4Rect1);
            this._e4Rect1.release();
            this._e4Rect1 = undefined;
        }
        if (this._e4Rect2) {
            this._e4Rect2.removeAllListeners();
            this._e4Rect2.parent && this._e4Rect2.parent.removeChild(this._e4Rect2);
            this._e4Rect2.release();
            this._e4Rect2 = undefined;
        }
        if (this._e4Line1) {
            this._e4Line1.removeAllListeners();
            this._e4Line1.parent && this._e4Line1.parent.removeChild(this._e4Line1);
            this._e4Line1.release();
            this._e4Line1 = undefined;
        }


        if (this._timeOutId != -1) {
            clearTimeout(this._timeOutId);
        }
        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }


}
